// // src/pages/Quotation/ViewQuotation.jsx

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   TextField,
//   Alert,
//     CircularProgress,
// } from "@mui/material";
// import { ArrowBack, Download, History, RequestQuote } from "@mui/icons-material";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// const API_URL = "http://api.onedesk.digital/api";

// export default function ViewQuotation() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [quotation, setQuotation] = useState(null);
//   const [openCounter, setOpenCounter] = useState(false);
//   const [counterAmount, setCounterAmount] = useState("");

//   useEffect(() => {
//     fetchQuotation();
//   }, [id]);

//   const fetchQuotation = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/quotations/${id}`);
//       setQuotation(res.data.quotation);
//     } catch (err) {
//       alert("Failed to load quotation");
//     }
//   };

//   const handleCounterOffer = async () => {
//     if (!counterAmount || counterAmount <= 0) return alert("Enter valid amount");
//     try {
//       await axios.post(`${API_URL}/quotations/${id}/counter`, { counter_amount: counterAmount });
//       alert("Counter offer sent!");
//       setOpenCounter(false);
//       fetchQuotation();
//     } catch (err) {
//       alert("Failed");
//     }
//   };

//   if (!quotation) return <Box textAlign="center" mt={10}><CircularProgress /></Box>;

//   return (
//     <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
//       <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
//         Back
//       </Button>

//       <Paper sx={{ p: 4 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//           <Box>
//             <Typography variant="h4" fontWeight="bold">
//               {quotation.quotation_no}
//             </Typography>
//             <Typography color="text.secondary">
//               {quotation.lead?.name} • {quotation.lead?.mobile}
//             </Typography>
//           </Box>
//           <Box textAlign="right">
//             <Chip label={quotation.status} color={quotation.status === "Approved" ? "success" : "info"} />
//             <Chip label={quotation.revision || "R0"} sx={{ ml: 1 }} />
//           </Box>
//         </Box>

//         <TableContainer component={Paper} sx={{ mb: 4 }}>
//           <Table>
//             <TableHead><TableRow><TableCell><strong>Item</strong></TableCell><TableCell><strong>Qty</strong></TableCell><TableCell><strong>Rate</strong></TableCell><TableCell><strong>Amount</strong></TableCell></TableRow></TableHead>
//             <TableBody>
//               {quotation.items.map((item, i) => (
//                 <TableRow key={i}>
//                   <TableCell>{item.item_name}</TableCell>
//                   <TableCell>{item.qty} {item.unit}</TableCell>
//                   <TableCell>₹{item.rate.toLocaleString()}</TableCell>
//                   <TableCell>₹{(item.qty * item.rate).toLocaleString()}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box textAlign="right" sx={{ maxWidth: 400, ml: "auto" }}>
//           <Typography>Subtotal: ₹{Number(quotation.subtotal).toLocaleString()}</Typography>
//           <Typography>GST ({quotation.tax_rate}%): ₹{Number(quotation.tax).toLocaleString()}</Typography>
//           <Typography variant="h5" fontWeight="bold" color="primary">
//             Grand Total: ₹{Number(quotation.grand_total).toLocaleString("en-IN")}
//           </Typography>
//         </Box>

//         <Box mt={4} textAlign="center">
//           <Button variant="contained" startIcon={<Download />} href={`${API_URL}/quotations/${id}/pdf`} target="_blank" sx={{ mr: 2 }}>
//             Download PDF
//           </Button>
//           {quotation.status !== "Approved" && quotation.status !== "Rejected" && (
//             <Button variant="outlined" color="warning" startIcon={<RequestQuote />} onClick={() => setOpenCounter(true)}>
//               Counter Offer
//             </Button>
//           )}
//         </Box>
//       </Paper>

//       {/* Counter Offer Modal */}
//       <Dialog open={openCounter} onClose={() => setOpenCounter(false)}>
//         <DialogTitle>Send Counter Offer</DialogTitle>
//         <DialogContent>
//           <Alert severity="info" sx={{ mb: 2 }}>
//             Original: ₹{Number(quotation.grand_total).toLocaleString()}
//           </Alert>
//           <TextField
//             fullWidth
//             label="Your Counter Amount"
//             type="number"
//             value={counterAmount}
//             onChange={(e) => setCounterAmount(e.target.value)}
//           />
//           <Box mt={2} textAlign="right">
//             <Button onClick={() => setOpenCounter(false)}>Cancel</Button>
//             <Button variant="contained" color="warning" onClick={handleCounterOffer}>
//               Send Counter Offer
//             </Button>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// }

// src/pages/Quotation/ViewQuotation.jsx

// import React, { useState, useEffect } from "react";
// import {
//   Box, Paper, Typography, Button, Table, TableBody, TableCell,
//   TableContainer, TableHead, TableRow, Chip, Dialog, DialogTitle,
//   DialogContent, TextField, Alert, CircularProgress
// } from "@mui/material";
// import { ArrowBack, Download, RequestQuote } from "@mui/icons-material";
// import { useParams, useNavigate } from "react-router-dom";
// import api from "../../utils/api";

// export default function ViewQuotation() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [quotation, setQuotation] = useState(null);
//   const [openCounter, setOpenCounter] = useState(false);
//   const [counterAmount, setCounterAmount] = useState("");

//   useEffect(() => { fetchQuotation(); }, [id]);

//   const fetchQuotation = async () => {
//     try {
//       const res = await api.get(`/quotations/${id}`);
//       setQuotation(res.data.quotation);
//     } catch (err) {
//       alert("Failed to load quotation");
//     }
//   };

//   const handleCounterOffer = async () => {
//     if (!counterAmount || counterAmount <= 0) return alert("Enter valid amount");
//     try {
//       await api.post(`/quotations/${id}/counter`, { counter_amount: counterAmount });
//       alert("Counter offer sent!");
//       setOpenCounter(false);
//       fetchQuotation();
//     } catch (err) {
//       alert("Failed");
//     }
//   };

//   if (!quotation) return <Box textAlign="center" mt={10}><CircularProgress /></Box>;

//   return (
//     <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
//       <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>Back</Button>

//       <Paper sx={{ p: 4 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//           <Box>
//             <Typography variant="h4" fontWeight="bold">{quotation.quotation_no}</Typography>
//             <Typography color="text.secondary">
//               {quotation.client_name} • {quotation.mobile}
//             </Typography>
//           </Box>
//           <Box textAlign="right">
//             <Chip label={quotation.status || "Draft"} color={quotation.status === "Approved" ? "success" : "info"} />
//             <Chip label={quotation.revision || "R0"} sx={{ ml: 1 }} />
//           </Box>
//         </Box>

//         <TableContainer component={Paper} sx={{ mb: 4 }}>
//           <Table>
//             <TableHead><TableRow><TableCell><strong>Item</strong></TableCell><TableCell><strong>Qty</strong></TableCell><TableCell><strong>Rate</strong></TableCell><TableCell><strong>Amount</strong></TableCell></TableRow></TableHead>
//             <TableBody>
//               {quotation.items?.map((item, i) => (
//                 <TableRow key={i}>
//                   <TableCell>{item.item_name}</TableCell>
//                   <TableCell>{item.qty} {item.unit}</TableCell>
//                   <TableCell>₹{Number(item.rate).toLocaleString()}</TableCell>
//                   <TableCell>₹{(item.qty * item.rate).toLocaleString()}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box textAlign="right" sx={{ maxWidth: 400, ml: "auto" }}>
//           <Typography>Subtotal: ₹{Number(quotation.total_amount).toLocaleString()}</Typography>
//           <Typography>GST ({quotation.tax_rate}%): ₹{Number(quotation.tax_amount).toLocaleString()}</Typography>
//           <Typography variant="h5" fontWeight="bold" color="primary">
//             Grand Total: ₹{Number(quotation.grand_total).toLocaleString("en-IN")}
//           </Typography>
//         </Box>

//         <Box mt={4} textAlign="center">
//           <Button variant="contained" startIcon={<Download />} href={`/api/quotations/${id}/pdf`} target="_blank" sx={{ mr: 2 }}>
//             Download PDF
//           </Button>
//           {quotation.status !== "Approved" && quotation.status !== "Rejected" && (
//             <Button variant="outlined" color="warning" startIcon={<RequestQuote />} onClick={() => setOpenCounter(true)}>
//               Counter Offer
//             </Button>
//           )}
//         </Box>
//       </Paper>
// {user.role === "Admin" && quotation.status === "Counter-Offer" && (
//   <Button 
//     variant="contained" 
//     color="success"
//     onClick={() => handleApproveAndRevise(quotation.id)}
//   >
//     Approve Counter & Send Revised Quotation
//   </Button>
// )}
//       <Dialog open={openCounter} onClose={() => setOpenCounter(false)}>
//         <DialogTitle>Send Counter Offer</DialogTitle>
//         <DialogContent>
//           <Alert severity="info" sx={{ mb: 2 }}>Original: ₹{Number(quotation.grand_total).toLocaleString()}</Alert>
//           <TextField fullWidth label="Your Counter Amount" type="number" value={counterAmount} onChange={e => setCounterAmount(e.target.value)} />
//           <Box mt={2} textAlign="right">
//             <Button onClick={() => setOpenCounter(false)}>Cancel</Button>
//             <Button variant="contained" color="warning" onClick={handleCounterOffer}>Send</Button>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// }


// src/pages/Quotation/ViewQuotation.jsx



import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  CircularProgress,
} from "@mui/material";
import { ArrowBack, Download, RequestQuote } from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function ViewQuotation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quotation, setQuotation] = useState(null);
  const [openCounter, setOpenCounter] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const [counterAmount, setCounterAmount] = useState("");
  const [counterNotes, setCounterNotes] = useState("");
  const [approveNotes, setApproveNotes] = useState("");

  // Get logged-in user from localStorage
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    fetchQuotation();
  }, [id]);

  const fetchQuotation = async () => {
    try {
      const res = await api.get(`/quotations/${id}`);
      setQuotation(res.data.quotation);
    } catch (err) {
      alert("Failed to load quotation");
    }
  };

  const handleCounterOffer = async () => {
    if (!counterAmount || counterAmount <= 0) return alert("Enter valid amount");
    try {
      await api.post(`/quotations/${id}/counter`, {
        counter_amount: counterAmount,
        counter_notes: counterNotes,
      });
      alert("Counter offer sent!");
      setOpenCounter(false);
      setCounterAmount("");
      setCounterNotes("");
      fetchQuotation();
    } catch (err) {
      alert("Failed to send counter offer");
    }
  };

  const handleApproveAndRevise = async () => {
    try {
      const res = await api.post(`/quotations/${id}/approve-revise`, {
        approved_notes: approveNotes,
      });
      alert(res.data.message);
      setOpenApprove(false);
      setApproveNotes("");
      fetchQuotation();
    } catch (err) {
      alert("Failed to approve and revise");
    }
  };

  if (!quotation) return <Box textAlign="center" mt={10}><CircularProgress /></Box>;

  return (
    <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back
      </Button>

      <Paper sx={{ p: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="h4" fontWeight="bold">
              {quotation.quotation_no}
            </Typography>
            <Typography color="text.secondary">
              {quotation.client_name} • {quotation.mobile}
            </Typography>
          </Box>
          <Box textAlign="right">
            <Chip label={quotation.status} color={quotation.status === "Approved" ? "success" : "info"} />
            <Chip label={quotation.revision || "R0"} sx={{ ml: 1 }} />
          </Box>
        </Box>

        <TableContainer component={Paper} sx={{ mb: 4 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Item</strong></TableCell>
                <TableCell><strong>Qty</strong></TableCell>
                <TableCell><strong>Rate</strong></TableCell>
                <TableCell><strong>Amount</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {quotation.items?.map((item, i) => (
                <TableRow key={i}>
                  <TableCell>{item.item_name}</TableCell>
                  <TableCell>{item.qty} {item.unit}</TableCell>
                  <TableCell>₹{Number(item.rate).toLocaleString()}</TableCell>
                  <TableCell>₹{(item.qty * item.rate).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box textAlign="right" sx={{ maxWidth: 400, ml: "auto" }}>
          <Typography>Subtotal: ₹{Number(quotation.total_amount).toLocaleString()}</Typography>
          <Typography>GST ({quotation.tax_rate}%): ₹{Number(quotation.tax_amount).toLocaleString()}</Typography>
          <Typography variant="h5" fontWeight="bold" color="primary">
            Grand Total: ₹{Number(quotation.grand_total).toLocaleString("en-IN")}
          </Typography>
        </Box>

        <Box mt={4} textAlign="center">
          <Button variant="contained" startIcon={<Download />} href={`/api/quotations/${id}/pdf`} target="_blank" sx={{ mr: 2 }}>
            Download PDF
          </Button>

          {/* Counter Offer Button */}
          {["Draft", "Sent", "Revised"].includes(quotation.status) && (
            <Button
              variant="outlined"
              color="warning"
              startIcon={<RequestQuote />}
              onClick={() => setOpenCounter(true)}
            >
              Counter Offer
            </Button>
          )}

          {/* Internal Approval Button (Admin only) */}
          {user.role === "Admin" && quotation.status === "Counter-Offer" && (
            <Button
              variant="contained"
              color="success"
              onClick={() => setOpenApprove(true)}
              sx={{ ml: 2 }}
            >
              Approve Counter & Create Revised Quotation
            </Button>
          )}
        </Box>
      </Paper>

      {/* Counter Offer Modal */}
      <Dialog open={openCounter} onClose={() => setOpenCounter(false)}>
        <DialogTitle>Send Counter Offer</DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            Original Amount: ₹{Number(quotation.grand_total).toLocaleString()}
          </Alert>
          <TextField
            fullWidth
            label="Your Counter Amount"
            type="number"
            value={counterAmount}
            onChange={(e) => setCounterAmount(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Notes (optional)"
            multiline
            rows={3}
            value={counterNotes}
            onChange={(e) => setCounterNotes(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCounter(false)}>Cancel</Button>
          <Button variant="contained" color="warning" onClick={handleCounterOffer}>
            Send Counter Offer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Approve & Revise Modal (Admin only) */}
      <Dialog open={openApprove} onClose={() => setOpenApprove(false)}>
        <DialogTitle>Approve Counter Offer & Create Revised Quotation</DialogTitle>
        <DialogContent>
          <Alert severity="success" sx={{ mb: 2 }}>
            Counter Amount: ₹{Number(quotation.counter_offer_amount).toLocaleString()}
          </Alert>
          <TextField
            fullWidth
            label="Approval Notes"
            multiline
            rows={4}
            value={approveNotes}
            onChange={(e) => setApproveNotes(e.target.value)}
            placeholder="e.g. Approved with 12% discount for bulk order"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenApprove(false)}>Cancel</Button>
          <Button variant="contained" color="success" onClick={handleApproveAndRevise}>
            Approve & Send Revised Quotation
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}